import { ROUTES } from "@lhd/constants";

export const useManagerTrackingPath = () => {
  const detailBase = `${ROUTES.TRACKING_TIME}${ROUTES.DETAIL}`;
  const listPath = `${ROUTES.TRACKING_TIME}${ROUTES.LIST}`;
  return { detailBase, listPath };
};
